module.exports = __webpack_public_path__ + "static/media/people.3d848993.png";